import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, signal, WritableSignal } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';

import { AssigneeService } from 'src/app/api/assignee.service';
import { UiSafeStaff } from 'src/app/api/commonInterfaces';
import { IncidentsService } from 'src/app/api/incidents.service';



export enum OnAssignValues {
  Dismissed = "dismissed",
  AssignSuccess = "assignSuccess",
  AssignError = "assignError"
}

@Component({
    selector: 'app-assign-incident',
    templateUrl: './assign-incident.component.html',
    styleUrls: ['./assign-incident.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssignIncidentComponent implements OnInit {


  @Input()
  showActionButtons: boolean = true;

  @Input()
  incidentId: number = -1;

  @Output()
  onAssign = new EventEmitter<OnAssignValues>();

 assignees: WritableSignal<UiSafeStaff[]> = signal([]);

  form = this.fb.group({
    assigneeId: ['']
  })

  constructor(
    private fb: UntypedFormBuilder,
    private incidentService: IncidentsService,
    private assigneeService: AssigneeService
  ) { }


  ngOnInit(): void {

    this.assigneeService.getAssignees().subscribe((data) => {
      this.assignees.set(data as unknown as UiSafeStaff[]);
    })
  }


  assignIncident() {
    const userId = this.form.value.assigneeId;
    if (userId && userId != "") {
        this.incidentService.assignIncident(this.incidentId, userId).subscribe({
          next: () => {
          this.onAssign.emit(OnAssignValues.AssignSuccess);
        },
          error: () => {
            this.onAssign.emit(OnAssignValues.AssignError);
          }
      })
      
    }
    
  }

}
